import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

const Item = ({
  children,
  exact,
  external = false,
  onClick,
  openInNewTab = false,
  url,
  rootPath,
}) => {
  const { currentUrl } = useDefaultAppContexts();

  if (external && !url.startsWith('/') && !url.startsWith(currentUrl.origin)) {
    return (
      <DefaultLinkStyled
        href={url}
        data-testid="link"
        role="menuItem"
        target={openInNewTab ? '_blank' : undefined}
        data-open-type={openInNewTab ? 'new_tab' : undefined}
        onClick={openInNewTab ? undefined : onClick}
      >
        {children}
      </DefaultLinkStyled>
    );
  }

  return (
    <NavLinkStyled
      to={url.replace(currentUrl.origin, '')}
      end={exact || url === rootPath}
      role="menuItem"
      data-testid="nav-link"
      onClick={onClick}
    >
      {children}
    </NavLinkStyled>
  );
};

Item.propTypes = {
  url: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  external: PropTypes.bool,
  openInNewTab: PropTypes.bool,
  onClick: PropTypes.func,
  rootPath: PropTypes.string,
};

export default Item;

// NOTE: We use generic class name, since we can't redefine the NavLink's
// classNames in conjunction with styled-components.
const activeClassName = 'active';

const NavLinkStyled = styled(NavLink)`
  display: block;
  position: relative;
  color: ${(props) => props.theme.colors.asphalt};
  height: 32px;
  display: flex;
  align-items: center;
  padding-left: ${(props) => props.theme.space[3]}px;
  user-select: none;

  &.${activeClassName} {
    background-color: ${(props) => props.theme.colors.primary};
    margin-bottom: 0;
    color: ${(props) => props.theme.colors.white};
    height: 32px;
    font-weight: ${(props) => props.theme.fontWeights[2]};
    display: flex;
    align-items: center;
  }
`;

const DefaultLinkStyled = styled(DefaultLink)`
  color: ${(props) => props.theme.colors.asphalt};
  height: 32px;
  display: flex;
  align-items: center;
  padding-left: ${(props) => props.theme.space[3]}px;
  user-select: none;
`;
